<template>
  <div class="screen-page main-layout">
    <el-card class="box-home">
      <ul class="s-top">
        <li>
          <div class="title">
            <span class="title-icon arrow-01"></span>
            <span class="title-name">新生总人数</span>
          </div>
          <span class="num">{{ totalNum }}</span>
        </li>
        <li>
          <div class="title">
            <span class="title-icon arrow-02"></span>
            <span class="title-name">已完成报到人数</span>
          </div>
          <span class="num">{{ doneNum }}</span>
        </li>
        <li>
          <div class="title">
            <span class="title-icon arrow-03"></span>
            <span class="title-name">未完成报到人数</span>
          </div>
          <span class="num">{{ todoNum }}</span>
        </li>
        <li class="last">
          <div class="title-item">
            <div class="title">
              <span class="title-icon arrow-04"></span>
              <span class="title-name">最热门院系</span>
            </div>
            <span class="name ellipsis">{{ hotCollegeName }}</span>
          </div>
          <div class="title-item">
            <div class="title">
              <span class="title-icon arrow-05"></span>
              <span class="title-name">最冷门院系</span>
            </div>
            <span class="name ellipsis">{{ coldCollegeName }}</span>
          </div>
        </li>
      </ul>
      <div class="div-scroll s-bottom">
        <ul class="s-content">
          <li
            class="s-item"
            :class="item.className"
            v-for="(item, index) in showList"
            :key="index"
          >
            <components :is="item.component"></components>
          </li>
        </ul>
      </div>
    </el-card>
  </div>
</template>

<script>
import moduleList from "@/assets/json/moduleList.js";
import ModuleOne from "./components/moduleOne";
import ModuleTwo from "./components/moduleTwo";
import ModuleThree from "./components/moduleThree";
import ModuleFour from "./components/moduleFour";
import ModuleSix from "./components/moduleSix";
import ModuleSeven from "./components/moduleSeven";
import ModuleFive from "./components/moduleFive.vue";
import ModuleTwelve from "./components/moduleTwelve.vue";
import { mapState } from "vuex";
export default {
  components: {
    ModuleOne, // 各院系新生人数
    ModuleTwo, // 新生报到人数
    ModuleThree, // 各院系新生报到情况
    ModuleFour, // 新生男女比例
    ModuleSix, // 新生专业调整情况
    ModuleSeven, // 各院系新生专业调整情况
    ModuleFive, // 报到行程统计
    ModuleTwelve, // 缴费情况统计
  },
  data() {
    return {
      drag: false,
      showList: [],
      totalNum: 0,
      doneNum: 0,
      todoNum: 0,
      enrollmentYear: "", // 入学年份
      coldCollegeName: "", // 最冷门专业
      hotCollegeName: "", // 热门专业
    };
  },
  computed: {
    ...mapState("dic", ["SUCCESS_CODE", "_CURRENTYEAR", "_CURRENT_ACADEMIC"]),
  },
  created() {
    this.enrollmentYear = this._CURRENTYEAR[0].value;
    this.showList = moduleList;
    this.getPrediectData();
    this.getHotColdCollege(); // 获取热门冷门专业
  },
  mounted() {},
  methods: {
    // 获取新生预报到情况数据
    getPrediectData() {
      let params = {
        enrollmentYear: this.enrollmentYear,
        academicDegree: this._CURRENT_ACADEMIC,
      };
      this.$http
        .get("/welcome-forecast/statistics/getForecastNum", { params })
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            console.log(res);
            this.totalNum = res.data.totalNum;
            this.doneNum = res.data.doneNum;
            this.todoNum = res.data.todoNum;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    // 获取最热门最冷门专业
    getHotColdCollege() {
      let params = {
        enrollmentYear: this.enrollmentYear,
        academicDegree: this._CURRENT_ACADEMIC,
      };
      this.$http
        .get("/welcome-forecast/statistics/getHotColdCollege", { params })
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            console.log(res);
            this.coldCollegeName = res.data.coldCollegeName;
            this.hotCollegeName = res.data.hotCollegeName;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
  },
};
</script>
